<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'Text format superscript',
    },
    isDecorative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ariaLabel() {
      return this.isDecorative ? null : this.title
    },
  },
}
</script>
<template>
  <svg
    role="img"
    :aria-label="ariaLabel"
    :aria-hidden="isDecorative"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m5 7 10 10M15 7 5 17M18 4.5a1.5 1.5 0 1 1 3 0c0 .485-.165.956-.468 1.335L18 9h3"/>
  </svg>
</template>
